import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import { getClients } from "../helpers/Clients";
import { Link } from "react-router-dom";
import { getVendors } from "../helpers/Vendors";


export default function Vendors() {
    const { appState } = useAppState();
    const [vendors, setVendors] = useState<Array<any>>([])

    useEffect(() => {
        getVendors().then((result) => {
            setVendors(result)
        })
    }, [])

    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Vendors</h1>
                <Link to="/vendors/create" className="px-4 py-2 bg-blue-500 text-white rounded">Create vendor</Link>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <table className="w-full">
                    <thead className="text-left">
                        <tr className="border-b-1">
                            <th className="p-2">Id</th>
                            <th className="p-2">Name</th>
                            <th className="p-2">Email</th>
                            <th className="p-2">Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vendors.map((vendor: any) => {
                            return (
                                <tr className="border-b-1 border-gray-300">
                                    <td className="p-2">{vendor.id}</td>
                                    <td className="p-2">{vendor.name}</td>
                                    <td className="p-2">{vendor.email}</td>
                                    <td className="p-2">{vendor.description}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </>
    );
}
